import styled from 'styled-components';
import { TGlobalColors } from '@pb/styles';

import { TStyledHorizontalLineProperties } from './horizontal-line.types';

export const StyledHorizontalLine = styled.div<TStyledHorizontalLineProperties>`
    margin-top: 1rem;
    margin-bottom: 1rem;
    border-bottom-color: ${({ color, theme }) =>
        theme.color[color as TGlobalColors]};
    border-bottom-width: 0.1rem;
    border-bottom-style: solid;
`;
